import SaleUtils from '@/services/SaleUtils'
// Fields to Comercial Information
export default [
    {
        //comercial fields[0] - Precio Costo
        field: 'cost_price',
        type: 'float',
        vuetifyProps: {
            label: 'Precio Costo',
            suffix: 'Pesos ($)',
        },
        rules: ['required'],
    },
    {
        //comercial fields[1] - Precio Venta
        field: 'sale_price',
        format: 'currency',
        type: 'text',
        vuetifyProps: {
            label: 'Precio Venta',
        },
        rules: ['required'],
    },
    {
        //comercial fields[1] - Precio Venta
        field: 'net_price',
        type: 'computed',
        vuetifyProps: {
            label: 'Precio Neto',
        },
        readonly: true,
        rules: [],
        computed: ({ sale_price }) => {
            return '$' + SaleUtils.getNetPrice(sale_price)
        },
    },
    {
        //comercial fields[2] - Margen
        field: 'gains_margin',
        type: 'computed',
        vuetifyProps: {
            label: 'Margen',
            suffix: '%',
        },
        readonly: true,
        rules: [],
        // TODO: Fix function to calc margin
        // TODO: parseInt both props
        computed: ({ sale_price, cost_price }) =>
            SaleUtils.getNewMargin(sale_price, cost_price),
        value: 0,
    },
    {
        //comercial fields[3]
        field: 'warranty_days',
        type: 'text',
        vuetifyProps: {
            label: 'Garantía (días)',
            mask: '####',
        },
        rules: ['required'],
    },
    {
        field: 'Información Global',
        type: 'section',
    },
    {
        //comercial fields[4] - Producto Vendible
        field: 'is_salable',
        type: 'checkbox',
        vuetifyProps: {
            label: 'Producto Vendible',
            'false-value': false,
        },
        value: false,
    },
    {
        //comercial fields[5] - Producto libre de impuestos
        field: 'is_tax_free',
        type: 'checkbox',
        vuetifyProps: {
            label: 'Producto Libre de Impuesto',
        },
        value: false,
    },
    {
        //comercial fields[6] - Producto consumo interno
        field: 'is_consumable',
        type: 'checkbox',
        vuetifyProps: {
            label: 'Producto Consumo Interno',
            'false-value': false,
        },
        value: false,
    },
]
